import React, { Component, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import './MessageForm.css';
import Message from '../message/Message';
import moment from 'moment';
import PropTypes from 'prop-types';
import enhance from './MessageForm.enhancer';
import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Dropzone from 'react-dropzone';
import { omit } from 'lodash';
import CircularProgress from '@material-ui/core/CircularProgress';

class MessageForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: '',
      message: '',
      list: [],
      isFileUploading: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.sendTo) {
      this.setState({
        userName: nextProps.user.email,
        sendTo: nextProps.sendTo
      });
    }
  }

  handleChange(event) {
    this.setState({ message: event.target.value });
  }

  handleSendMessage() {
    var newItem = {
      userName: this.state.userName,
      message: this.state.message,
      sentBy: this.props.user.uid,
      sentTo: this.props.sendTo.id,
      dateTime: this.props.firebase.database.ServerValue.TIMESTAMP
    };
    this.handleSend(newItem);
    this.setState({ message: '' });
  }

  handleSendAttachment(downloadUrl, acceptedFile) {
    var newItem = {
      userName: this.state.userName,
      downloadUrl,
      sentBy: this.props.user.uid,
      sentTo: this.props.sendTo.id,
      dateTime: this.props.firebase.database.ServerValue.TIMESTAMP,
      isAttachment: true,
      fileName: acceptedFile
    };
    this.handleSend(newItem);
  }

  handleSend(newItem) {
    if (
      (newItem.message || newItem.downloadUrl) &&
      !this.props.readonly &&
      this.props.sendTo.id
    ) {
      this.props.firebase.push(
        `/messages/${this.props.user.uid}/${newItem.sentTo}`,
        newItem
      );
      this.props.firebase.push(
        `/messages/${newItem.sentTo}/${this.props.user.uid}`,
        newItem
      );
    }
  }

  // handleKeyPress(event) {
  //   if (event.key !== 'Enter') return;
  //   event.preventDefault();
  //   this.handleSendMessage();
  // }

  render() {
    const { classes } = this.props;
    return (
      <div className="form">
        <div className="form__message">
          {this.props.readonly && (
            <Message
              key={this.state.list.length - 1}
              message={{ message: 'You are no longer matched with this user' }}
            />
          )}
        </div>
        <div className="form__row">
          {!this.state.isFileUploading && (
            <Dropzone
              onDropAccepted={acceptedFile => {
                this.setState({ isFileUploading: true });
                var user = this.props.firebase.auth().currentUser;
                const filePath = `${user.uid}/messageAttachments`;
                const options = {
                  metadataFactory: uploadRes => {
                    const { metadata } = uploadRes;
                    const cleanMeta = omit(metadata, [
                      'cacheControl',
                      'contentLanguage',
                      'customMetadata'
                    ]);
                    return cleanMeta;
                  }
                };

                this.props.firebase
                  .uploadFiles(filePath, acceptedFile, filePath, options)
                  .then(file => {
                    this.setState({ isFileUploading: false });
                    file[0].uploadTaskSnapshot.ref
                      .getDownloadURL()
                      .then(downloadUrl => {
                        this.handleSendAttachment(
                          downloadUrl,
                          acceptedFile[0].name
                        );
                      });
                  });
              }}
              minSize={0}
              maxSize={5242880}
              multiple={false}
            >
              {({
                getRootProps,
                getInputProps,
                isDragActive,
                isDragReject,
                rejectedFiles
              }) => {
                const isFileTooLarge =
                  rejectedFiles.length > 0 && rejectedFiles[0].size > 5242880;

                return (
                  <div {...getRootProps({ className: 'dropzone' })}>
                    <input {...getInputProps()} />
                    <Button className={classes.uploadButton}>
                      <AttachFileIcon />
                    </Button>
                    {isFileTooLarge && (
                      <div className="text-danger mt-2">File is too large.</div>
                    )}
                  </div>
                );
              }}
            </Dropzone>
          )}
          {this.state.isFileUploading && (
            <div className={classes.spinnerContainer}>
              <CircularProgress className={classes.downArrow} />
            </div>
          )}
          <TextField
            className="form__input"
            type="text"
            placeholder="Type message"
            value={this.state.message}
            onChange={this.handleChange.bind(this)}
            // onKeyPress={this.handleKeyPress.bind(this)}
            multiline
            variant="outlined"
          />
          <Button
            color="primary"
            variant="contained"
            className="form__button"
            onClick={this.handleSendMessage.bind(this)}
            disabled={!this.props.sendTo || this.props.readonly}
          >
            send
          </Button>
        </div>
      </div>
    );
  }
}

export default enhance(MessageForm);



// WEBPACK FOOTER //
// ./src/components/messaging/conversation/message-form/MessageForm.js